import { Form, Input, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import clsx from "clsx";
import { useState } from "react";
import ReactCountryFlag from "react-country-flag";
import CustomInput from "src/components/custom-input/custom-input.component";
import Label from "src/components/label/label.component";

const { Option } = Select;

const BankForm: React.FC<any> = ({
  bank,
  index,
  onSubmit,
  countriesList,
  banksData,
  standingData,
  currenciesList,
  setSelectedBank,
  setOpenDeleteModal,
  accountDetails,
}) => {
  const [form] = Form.useForm();
  const [selectedCountryId, setSelectedCountryId] = useState<any>(bank?.accountCountry?.id || bank?.accountCountryId);

  return (
    <Form
      className="add-edit-form"
      scrollToFirstError={true}
      name={`formPerson${index}`}
      form={form}
      onFinish={(values) => onSubmit(values)}
      initialValues={{
        id: bank?.id,
        accountCountryId: bank?.accountCountry?.id || bank?.accountCountryId,
        bankId: bank?.bankId,
        currencyId: bank?.currencyId,
        accountNumber: bank?.accountNumber,
        ibanNumber: bank?.ibanNumber,
        swiftCode: bank?.swiftCode,
        additionalInfo: bank?.additionalInfo,
      }}
    >
      <div className="fields flex justify-between flex-wrap">
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>
        <div className="field flex column">
          <Label text="Country" required />
          <Form.Item
            name="accountCountryId"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
                message: "Please select country!",
              },
            ]}
          >
            <Select
              placeholder="Select Country"
              allowClear
              showSearch
              onChange={(value) => {
                setSelectedCountryId(value);
                form.setFieldsValue({
                  bankId: undefined,
                  currencyId: undefined,
                  ibanNumber: undefined,
                });
              }}
              filterOption={(input, option) => {
                return (option?.key?.toLowerCase() ?? "").includes(
                  input.toLowerCase()
                );

              }}
            >
              {countriesList?.map((country: any) => (
                <Option value={country.id} key={country.nameEn}>
                  <div className="flex items-center gap-1">
                    <ReactCountryFlag
                      style={{
                        fontSize: "24px",
                        marginInlineEnd: "8px",
                      }}
                      countryCode={country?.countryCode}
                      svg
                    />
                    <span>{country.nameEn}</span>
                  </div>
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div className="field flex column">
          <Label text="Bank Name" required />
          <Form.Item
            name="bankId"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
                message: "Please select bank name!",
              },
            ]}
          >
            <Select
              placeholder="Select Bank Name"
              options={banksData?.filter((item: any) => item.countryid === selectedCountryId && (item.branch?.toLowerCase() === 'gc' || item?.branch?.toLowerCase() === 'sa'))?.map((item: any) => {
                return { value: item.id, label: item.bankName };
              })}
            />
          </Form.Item>
        </div>
        <div className="field flex column">
          <Label text="Currency" required />
          <Form.Item
            name="currencyId"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
                message: "Please select currency!",
              },
            ]}
          >
            <Select
              placeholder="Select currency"
              allowClear
              showSearch
              filterOption={(input, option) =>
                (option?.children as any)?.props?.children
                  ?.toString()
                  ?.toLowerCase()
                  ?.includes(input.toLowerCase())
              }
            >
              {currenciesList?.map((country: any) => (
                <Option value={country.id} key={country.currencyCode}>
                  <span>{country.currencyCode} - {country.longNameEn}</span>
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        <div className="field flex column">
          <Label text="IBAN No." required />
          <Form.Item
            name="ibanNumber"
            validateTrigger={["onChange", "onBlur"]}
            normalize={(value) => value?.toUpperCase()}
            rules={[
              {
                required: true,
                message: "Please input IBAN No.!",
              },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();
                  const selectedCountry = countriesList?.find(
                    (c: any) => c.id === selectedCountryId
                  );
                  if (selectedCountry?.countryCode) {
                    const code = selectedCountry.countryCode;
                    const upperValue = value.toUpperCase();
                    if (!upperValue.startsWith(code)) {
                      return Promise.reject(
                        `IBAN must start with ${code}`
                      );
                    }
                    if (code === "SA") {
                      const afterCode = upperValue.slice(code.length);
                      if (afterCode && !/^\d+$/.test(afterCode)) {
                        return Promise.reject(
                          `IBAN must have only digits after ${code}`
                        );
                      }
                    }
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <CustomInput placeholder="enter IBAN No." maxLength={34} />
          </Form.Item>
        </div>

      </div>
      <div className="flex w-full flex-wrap items-center justify-end mt-7 border-t-[1px] border-gray-900 pt-5">
        <div
          className={clsx(
            "flex items-center w-[70%] md:w-[48%]",
            bank?.id ? "justify-between" : "justify-end"
          )}
        >
          {bank?.id && (
            <button
              type="button"
              onClick={() => {
                setSelectedBank(bank);
                setOpenDeleteModal(true);
              }}
              className="rounded-lg bg-red-200 text-white w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-red-200"
            >
              Delete
            </button>
          )}
          <button
            type="submit"
            className="disabled:opacity-50 disabled:cursor-not-allowed rounded-lg bg-blue-500 w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-white"
          >
            Save
          </button>
        </div>
      </div>
    </Form>
  );
};

export default BankForm;
